import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import { LinkedArticleType, ScipSubmissionData } from "../../../store/Models/Surveys/SurveyDataModel";
import { useEffect, useState } from "react";

import "./styles.css";

interface LinkedArticlesProps {
    onSubArticleSelect: (subArticle: ScipSubmissionData) => void;
    localizer: IStringLocalizer;
    existingLinkedArticles: LinkedArticleType[];
    registerPopoversCb: (popoverIds: string[]) => void;
}

const LinkedArticles: React.FC<LinkedArticlesProps> = ({ onSubArticleSelect, localizer, existingLinkedArticles, registerPopoversCb }) => {
    const [currentLinkedArticles, setCurrentLinkedArticles] = useState(existingLinkedArticles);

    useEffect(() => {
        registerPopoversCb(['no-units-popover']);
    }, []);

    useEffect(() => {
        setCurrentLinkedArticles(existingLinkedArticles);
    }, [existingLinkedArticles]);

    return (
        <>
            <h4>{localizer.localizeString("Linked Articles")}</h4>
            <div className="table-container">
                <table className="table toxnot-table-v2">
                    <thead>
                        <tr key={"linked-element"}>
                            <th key={"linked-article-name"}>{localizer.localizeString("Article")}</th>
                            <th key={"scip-number"}>{localizer.localizeString("SCIP Number")}</th>
                            <th key={"no-of-units"}>
                                {localizer.localizeString("Number of Units")}
                                <a id="no-units-popover" data-container="body" role="button" className="m-l-5" data-toggle="popover" data-html="true" data-placement="bottom" data-content={localizer.localizeString("Edit this through the Quantity column in the Ingredient Disclosure Data editor")}>
                                    <img height="14" src="/images/help-icon-dark-gray.png" />
                                </a>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="data-table">
                        {currentLinkedArticles.map((la, index) => {
                            const resolvedScipNumber = la.submissionData.isScipNumberManuallyEntered ? la.submissionData.scipNumber ?? "" : "";

                            return (
                                <tr key={index}>
                                    <td>
                                       <a role="button" onClick={(e) => onSubArticleSelect(la.submissionData)}>{la.submissionData.articleName}</a>
                                    </td>
                                    <td>{resolvedScipNumber}</td>
                                    <td>{la.numberOfUnits}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default LinkedArticles;
